import { AppRoute } from 'apps/woundscantwait-com/src/libs/enums/enums';
import { RoundedBorder } from '../../../../_libs/components/components';

const HealthcareGuidanceCard = () => {
  return (
    <RoundedBorder
      to={AppRoute.RESOURCES_SUPPORT}
      className="mt-8 rounded-[6px] max-w-[980px]"
      captionClassName="text-[18px] lg:text-[min(1.7vw,24px)] font-roboto-condensed"
      caption="Talk to your healthcare and insurance providers to find the Organogenesis product that will be the most helpful with healing your wound."
    />
  );
};

export { HealthcareGuidanceCard };
